import { useQuery } from '@tanstack/react-query';
import { stepApprovalRequestCount } from '../api/candidates';
import { usePermission } from '../auth/usePermission';
import { STEP_APPROVAL_REQUESTS_COUNT_QUERY_KEY } from '../pages/candidates/StepApprovalRequests';

const STEP_APPROVAL_PERM = ['workflow.approval.level1', 'workflow.approval.level2', 'workflow.approval.level3'];

/**
 * Pending step-approval count for the sidebar badge. Polled rather than pushed — there's no
 * websocket/SSE layer in this app — at a slow enough interval that it stays cheap.
 */
export function useStepApprovalCount() {
  const { can } = usePermission();
  const enabled = can(STEP_APPROVAL_PERM);

  const query = useQuery({
    queryKey: STEP_APPROVAL_REQUESTS_COUNT_QUERY_KEY,
    queryFn: stepApprovalRequestCount,
    enabled,
    refetchInterval: 60_000,
  });

  return enabled ? (query.data ?? 0) : 0;
}
